<template>
  <div id="income-chart">
    <div class="income-chart-title">收费情况</div>
    <div class="dv-charts-container">
      <p class="item">应收金额: <span class="value">{{ amountReceivable }}</span></p>
      <p class="item">实收金额: <span class="value" style="color: #3ff9ed">{{ amountReceived }}</span></p>
      <p class="item">欠费租户户数: <span class="value" style="color: #f46827">{{ households }}</span></p>
      <p class="item">欠费率: <span class="value">{{ rate }}%</span></p>
    </div>
  </div>
</template>
<script>

import { formatNumber } from '@/utils/common'
import { getRandomNumber } from '@/utils/common'

export default {
  name: 'Income',
  data() {

    return {
      amountReceivable: '¥' + formatNumber(getRandomNumber(28000000, 30000000)),
      amountReceived: '¥' + formatNumber(getRandomNumber(26000000, 28000000)),
      households: getRandomNumber(12, 30),
      rate: getRandomNumber(0.01, 0.4)
    }
  }
}
</script>
<style scoped lang="less">
#income-chart {
  width: 30%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  box-sizing: border-box;

  .income-chart-title {
    height: 50px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .dv-charts-container {
    height: calc(~"100% - 50px");
    padding: 20px;

    .item {
      font-size: 14px;
    }

    .value {
      font-size: 35px;
      font-weight: bold;
      color: #58a1ff;
      margin: 0 5px;
      margin-bottom: -5px;
    }

  }
}

</style>
